import {AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
declare let $: any;
import { ApiService } from './shared';

import '../style/app.scss';
import {Router} from '@angular/router';
import {HttpService} from "./shared/http.service";

@Component({
  selector: 'my-app', // <my-app></my-app>
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})
export class AppComponent implements OnInit, AfterViewInit{
  url = 'https://github.com/preboot/angular2-webpack';
  title: string;
  newsInterval: any;
  menu: Array<object>;
  categoryMenus: any;
  news: Array<object>;
  route: String;
  preloader: boolean;
  toTopButton: boolean;
  @Output() path: EventEmitter<any> = new EventEmitter();
  @Output() newsData: EventEmitter<any> = new EventEmitter();

  constructor(private api: ApiService, private router: Router, private http: HttpService) {
    this.title = this.api.title;
    this.menu = [];
    this.news = [];
    this.categoryMenus = false;
    this.preloader = false;
    this.init();
    this.router.events.subscribe(e => {
        this.route = e['url'];
        this.path.emit(e);
        this.checkSelected();

        if (this.route == '/') {
          this.activateRevo();
        }else {
          clearInterval(this.newsInterval);
        }
    });
  }

  ngAfterViewInit() {
    this.activateRevo();
  }

  setPreloader(val) {
    let self = this;
    // setTimeout(function () {
      self.preloader = val;
    // }, 5);
  }

  activateRevo() {
    let self = this;
    setInterval(function () {
      if (self.route == '/' && $(".initSlide").length > 0 && self.news.length > 0){
        clearInterval(this.newsInterval);
        $('.tp-banner').show().revolution(
            {
              dottedOverlay:"none",
              delay:16000,
              startwidth:1170,
              startheight:720,
              hideThumbs:200,

              thumbWidth:100,
              thumbHeight:50,
              thumbAmount:5,

              navigationType:"nexttobullets",
              navigationArrows:"solo",
              navigationStyle:"preview",

              touchenabled:"on",
              onHoverStop:"on",

              swipe_velocity: 0.7,
              swipe_min_touches: 1,
              swipe_max_touches: 1,
              drag_block_vertical: false,

              parallax:"mouse",
              parallaxBgFreeze:"on",
              parallaxLevels:[7,4,3,2,5,4,3,2,1,0],

              keyboardNavigation:"off",

              navigationHAlign:"center",
              navigationVAlign:"bottom",
              navigationHOffset:0,
              navigationVOffset:20,

              soloArrowLeftHalign:"left",
              soloArrowLeftValign:"center",
              soloArrowLeftHOffset:20,
              soloArrowLeftVOffset:0,

              soloArrowRightHalign:"right",
              soloArrowRightValign:"center",
              soloArrowRightHOffset:20,
              soloArrowRightVOffset:0,

              shadow:0,
              fullWidth:"on",
              fullScreen:"off",

              spinner:"spinner4",

              stopLoop:"off",
              stopAfterLoops:-1,
              stopAtSlide:-1,

              shuffle:"off",

              autoHeight:"off",
              forceFullWidth:"off",



              hideThumbsOnMobile:"off",
              hideNavDelayOnMobile:1500,
              hideBulletsOnMobile:"off",
              hideArrowsOnMobile:"off",
              hideThumbsUnderResolution:0,

              hideSliderAtLimit:0,
              hideCaptionAtLimit:0,
              hideAllCaptionAtLilmit:0,
              startWithSlide:0,
              videoJsPath:"rs-plugin/videojs/",
              fullScreenOffsetContainer: ""
            });
      }
    }, 100);
  }

  ngOnInit() {
    this.getNews();
  }

  getNews() {
    let url = '?json=get_category_posts&slug=news&status=publish';
    this.http.get(url).subscribe(
      data => {
        this.news = data['posts'];
        this.newsData.emit({data: this.news});
      },
      err => {
        console.log(err);
        this.newsData.emit({data: this.news});
      });
  }

  checkSelected() {
    for (let i in this.menu) {
      let menu = this.menu[i];
      let val = menu['value'].split('/');
      menu['active'] = false;
      if (this.route !== 'undefined') {
        let path = this.route.split('/');
        if (path[1] && val[1] && path[1] === val[1]){
          menu['active'] = true;
        }else if(!path[1] && !val[1] && path[0] === val[0]) {
          menu['active'] = true;
        }
      }
    }
  }

  @HostListener("window:scroll", [])
  onScroll() {
    this.toTopButton = window.pageYOffset > 300;
  }

  toTop() {
    window.scroll(0, 0);
  }

  createNewLink(cat, item) {
    if (item['post_status'] === 'publish') {
      if (!item['url'] || item['url'] === '#') {
        delete item['url'];
        return item;
      }

      if (item['object'] === 'page') {
        item['url'] = '/' + item['title'];
      }else if (item['object'] === 'post') {
        let urlSplit = item['url'].split('=');
        item['url'] = '/' + cat + '/' + urlSplit[1];
      }
      return item;
    }else {
      return false;
    }
  }

  createCategoryMenu(data) {
    this.categoryMenus = {};

    let createChilds = function (entry) {
      if(!entry['childs']) {
        entry['childs'] = [];
      }
      return entry;
    };

    for (let i in data) {
      let category = data[i];
      this.categoryMenus[i] = [];
      let entryTree = [];
      for (let n in category) {
        let item = category[n];
        item = this.createNewLink(i, item);

        if (!item) {
          continue;
        }

        let addNew = function (entryItem, itemAdd) {
          entryItem = createChilds(entryItem['item']);
          entryItem['childs'].push(itemAdd);
          entryTree.unshift({'id': itemAdd['ID'], 'item': itemAdd} );
        };

        if (item['menu_item_parent'] == 0) {
          entryTree = [];
          this.categoryMenus[i].push(item);
          entryTree.unshift({'id': item['ID'], 'item': item} );
        }else {
          if (entryTree[0]['id'] === Number(item['menu_item_parent'])) {
            addNew(entryTree[0], item);
          }else {
            let m = 0;
            let countWhile = entryTree.length;
            while (m < countWhile) {
              if (entryTree[0]['id'] === Number(item['menu_item_parent'])) {
                addNew(entryTree[0], item);
                m = countWhile;
              }else {
                entryTree.shift();
              }
              m++;
            }
          }
        }
      }
    }
  }

  init() {
    this.menu = [
      {
        name: 'Главная',
        value: '/'
      },
      {
        name: 'Эпиляция',
        value: '/epilation'
      },
      {
        name: 'Косметология',
        value: '/cosmetology'
      },
      {
        name: 'Массаж',
        value: '/massage'
      },
      {
        name: 'Хирургия',
        value: '/surgery'
      },
      {
        name: 'Дерматология',
        value: '/dermatology'
      },
      {
        name: 'Контакты',
        value: 'contact-us',
        type: 'anchor'
      },
      {
        name: 'Новости',
        value: 'news',
        type: 'none'
      }
    ];
    let url = '?json=menus/get_menus';
    this.http.get(url).subscribe(
      data => {
        if (data['menus']) {
          this.createCategoryMenu(data['menus']);
        }
      },
      err => {
        console.log(err);
      });
  }

  findPos(obj) {
    let curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while (obj = obj.offsetParent);
      return curtop;
    }
  }

  goTo(item) {
    if (item['type'] === 'anchor') {
      let elem = document.getElementsByClassName(item['value'])[0];
      let elemPos = this.findPos(elem);
      window.scroll(0, elemPos);
      this.onScroll();
    }else {
      this.router.navigateByUrl(item['value']);
    }
  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts